export const isLocalhost = document.location.hostname.includes('localhost');